import { render, staticRenderFns } from "./oilInfor.vue?vue&type=template&id=002b5288&scoped=true&"
import script from "./oilInfor.vue?vue&type=script&lang=js&"
export * from "./oilInfor.vue?vue&type=script&lang=js&"
import style0 from "./oilInfor.vue?vue&type=style&index=0&id=002b5288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b5288",
  null
  
)

export default component.exports